import gql from 'graphql-tag';

export type {
  FindByOrganizationIdAndIncludeDeletedRequest,
  FindByOrganizationIdAndIncludeDeletedResponse,
  FindByProgramIdsOrContractIdsOrBothAndIncludeDeletedRequest,
  FindByProgramIdsOrContractIdsOrBothAndIncludeDeletedResponse,
} from '@coursera/grpc-types-enterpriseuser/coursera/proto/enterpriseuser/rosters/v1/rosters_api';

const adminHomeRostersQuery = gql`
  query AdminHomeRostersQuery(
    $byProgramInput: FindByProgramIdsOrContractIdsOrBothAndIncludeDeletedRequest!
    $byOrgInput: FindByOrganizationIdAndIncludeDeletedRequest!
  ) {
    byProgram: byProgram(input: $byProgramInput)
      @rest(
        type: "FindByProgramIdsOrContractIdsOrBothAndIncludeDeleted"
        path: "grpc/enterpriseuser/rosters/v1/RostersAPI/FindByProgramIdsOrContractIdsOrBothAndIncludeDeleted"
        method: "POST"
      ) {
      rosterRecords
    }
    byOrg: byOrg(input: $byOrgInput)
      @rest(
        type: "FindByOrganizationIdAndIncludeDeleted"
        path: "grpc/enterpriseuser/rosters/v1/RostersAPI/FindByOrganizationIdAndIncludeDeleted"
        method: "POST"
      ) {
      rosterRecords
    }
  }
`;

export default adminHomeRostersQuery;
